//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import AdminSectionContent from '~/components/admin-sections/section-content.vue'
import AdminSectionGallery from '~/components/admin-sections/section-gallery.vue'
import AdminSectionGalleryWithText from '~/components/admin-sections/section-gallery-with-text.vue'
import AdminSectionFeatures from '~/components/admin-sections/section-features.vue'
import AdminSectionBlog from '~/components/admin-sections/section-blog.vue'
import AdminSectionFeaturesWithNumber from '~/components/admin-sections/section-features-with-number.vue'
import AdminSectionImageWithText from '~/components/admin-sections/admin-section-image-with-text.vue'

export default {
  name: 'AdminSections',
  components: {
    AdminSectionImageWithText,
    AdminSectionFeaturesWithNumber,
    AdminSectionBlog,
    AdminSectionFeatures,
    AdminSectionGalleryWithText,
    AdminSectionGallery,
    AdminSectionContent
  },
  props: {
    pageData: {
      type: Object,
      default: () => {
      }
    },
    sections: {
      type: Array
    }
  }
}

